import { Grid, ListItemButton, Typography } from "@mui/material";
import {
  NavLink,
  useMatch,
  useResolvedPath,
  useLocation,
} from "react-router-dom";

import IconButton from "../IconButton";
import { forwardRef } from "react";
import { styled } from "@mui/system";

const StyledNavLink = styled(NavLink)`
  display: flex;
  justify-content: center;

  &:hover {
    background-color: inherit;
  }
`;
const Item = styled(ListItemButton)`
  padding: 0;
  font-weight: ${(props) => props.theme.typography.fontWeightRegular};
  svg {
    font-size: 16px;
    width: 16px;
    height: 16px;
    opacity: 1;
  }
`;
const CustomRouterLink = forwardRef((props, ref) => (
  <div ref={ref}>
    <StyledNavLink {...props} />
  </div>
));

const Title = styled(Typography)`
  color: ${(props) => (props.active ? props.theme.palette.primary.main : "")};
`;

const NavBarItem = ({ item, test, ...props }) => {
  const { href, icon: Icon } = item;
  let resolved = useResolvedPath(href || "");
  const match = useMatch({ path: resolved.pathname, end: true });
  const location = useLocation();

  let active;
  if (resolved.pathname.length > 1) {
    location.pathname.includes(resolved.pathname.split("/").pop())
      ? (active = true)
      : (active = false);
  }
  return (
    <Item
      component={CustomRouterLink}
      disableRipple
      to={href}
      activeclassname="active"
    >
      <Grid container flexDirection="column" alignItems="center">
        <Grid item>
          <IconButton disableRipple $active={!!match || active}>
            <Icon active={!!match || active} />
          </IconButton>
        </Grid>
        <Grid item>
          <Title active={!!match || active} sx={{ fontSize: [7, 10] }} noWrap>
            {item?.title}
          </Title>
        </Grid>
      </Grid>
    </Item>
  );
};

export default NavBarItem;
